var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import CheckboxMui from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { colorPalette } from '@repo/mui-config/color-palette';
var BpIcon = styled('span', {
    shouldForwardProp: function (prop) { return prop !== 'error'; },
})(function (_a) {
    var error = _a.error, variant = _a.variant;
    var getBackgroundColor = function () {
        if (error)
            return colorPalette.error.light;
        if (variant === 'default')
            return colorPalette.white;
        return 'transparent';
    };
    var getBoxShadow = function () {
        if (error)
            return "inset 0 0 0 1.5px ".concat(colorPalette.error.main, ", inset 0 -1px 0 ").concat(colorPalette.error.main);
        if (variant === 'default')
            return "inset 0 0 0 1.5px ".concat(colorPalette.ink.light, ", inset 0 -1px 0 ").concat(colorPalette.ink.light);
        return "inset 0 0 0 1.5px ".concat(colorPalette.info.light, ", inset 0 -1px 0 ").concat(colorPalette.info.light);
    };
    return {
        borderRadius: 3,
        width: 18,
        height: 18,
        boxShadow: getBoxShadow(),
        backgroundColor: getBackgroundColor(),
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            filter: 'brightness(0.9)',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: error ? colorPalette.error.light : colorPalette.white,
        },
    };
});
var BpCheckedIcon = styled(BpIcon)({
    backgroundColor: colorPalette.white,
    '&::before': {
        display: 'block',
        width: 18,
        height: 18,
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23000000'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        filter: 'brightness(0.9)',
    },
});
export function Checkbox(_a) {
    var name = _a.name, labelProps = _a.labelProps, _b = _a.label, label = _b === void 0 ? '' : _b, noSpacing = _a.noSpacing, _c = _a.displayValidationError, displayValidationError = _c === void 0 ? false : _c, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, rest = __rest(_a, ["name", "labelProps", "label", "noSpacing", "displayValidationError", "variant"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var _b;
            var _c = _a.field, value = _c.value, restField = __rest(_c, ["value"]), fieldState = _a.fieldState;
            return (_jsxs(Stack, { children: [_jsx(Stack, { alignItems: "center", direction: "row", display: "inline", children: _jsx(FormControlLabel, { control: _jsx(CheckboxMui, __assign({ checkedIcon: _jsx(BpCheckedIcon, { error: Boolean(fieldState.error), variant: variant }), color: "default", disableRipple: true, icon: _jsx(BpIcon, { error: Boolean(fieldState.error), variant: variant }), sx: {
                                    color: fieldState.error ? colorPalette.error.main : undefined,
                                    padding: noSpacing ? 0 : '9px',
                                } }, restField, { checked: typeof value === 'boolean' ? value : undefined, name: name }, rest)), label: _jsx(Typography, __assign({}, labelProps, { children: label })), sx: {
                                marginRight: '5px',
                            } }) }), displayValidationError && ((_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) && (_jsx(Typography, { variant: "caption", color: colorPalette.error.main, sx: { marginLeft: '14px' }, children: fieldState.error.message }))] }));
        } }));
}
